"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalLoadingProvider = exports.useGlobalLoading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const GlobalLoadingContext = React.createContext({
    globalLoading: true,
    setGlobalLoading: () => undefined,
});
function useGlobalLoading() {
    return React.useContext(GlobalLoadingContext);
}
exports.useGlobalLoading = useGlobalLoading;
function GlobalLoadingProvider({ children, routesWithoutLoading }) {
    const location = (0, react_router_dom_1.useLocation)();
    const hasToRender = routesWithoutLoading.includes(location?.pathname);
    const [globalLoading, setGlobalLoading] = React.useState(!hasToRender);
    return (0, jsx_runtime_1.jsx)(GlobalLoadingContext.Provider, { value: { globalLoading, setGlobalLoading }, children: children });
}
exports.GlobalLoadingProvider = GlobalLoadingProvider;
//# sourceMappingURL=useGlobalLoading.hook.js.map